export const automationGerman = {
  title: 'KI-Steuerung',
  paused: 'KI pausiert',
  active: 'KI aktiv',
  takeover: 'Selbst übernehmen',
  resume: 'KI übernimmt wieder',
  pending: 'Wird aktualisiert …',
  loading: 'KI-Status wird geladen …',
  unavailable: 'Der KI-Status ist nicht erreichbar.',
  retry: 'Erneut laden',
  forbidden: 'Für die KI-Steuerung fehlt die aktuelle Plugin-Berechtigung.',
  stale: 'Der Stand wurde geändert. Bitte die aktuellen Angaben prüfen und erneut ausführen.',
  unknown: 'Die Antwort ist ausgeblieben. Ob die Änderung gespeichert wurde, wird neu geprüft.',
  failed: 'Die Änderung konnte nicht ausgeführt werden.',
  configure: 'Zuständigkeit und Modus',
  owner: 'Zuständiges Plugin',
  none: 'Kein Plugin',
  mode: 'Betriebsmodus',
  save: 'Speichern',
  Disabled: 'Ausgeschaltet',
  Copilot: 'Entwurfsassistent',
  Shadow: 'Beobachtungsmodus',
  Autopilot: 'Automatische Antworten',
  automation_disabled: 'Die KI ist ausgeschaltet.',
  automation_owner_missing: 'Es ist kein Plugin zugewiesen.',
  automation_owner_unavailable:
    'Die Plugin-Freigabe ist nicht mehr aktuell. Ein Admin muss die Zuständigkeit neu zuweisen.',
  automation_activation_required: 'Die erforderliche Objekt- und Qualitätsfreigabe fehlt.',
  conversation_closed: 'Das Gespräch ist geschlossen.',
  conversation_locally_resolved:
    'Die Unterhaltung ist manuell erledigt. Neue Gastnachrichten öffnen sie wieder.',
  reply_not_supported: 'Dieser Kanal unterstützt keine Antworten.',
  notReady: 'Die KI ist noch nicht betriebsbereit.',
  noPermission: 'Nur ein berechtigtes Teammitglied kann die KI bedienen.',
};
export const automationEnglish = {
  title: 'AI control',
  paused: 'AI paused',
  active: 'AI active',
  takeover: 'Take over',
  resume: 'Resume AI',
  pending: 'Updating …',
  loading: 'Loading AI status …',
  unavailable: 'The AI status is unavailable.',
  retry: 'Reload',
  forbidden: 'Current plugin permission is required to control AI.',
  stale: 'The state has changed. Review the current details and try again.',
  unknown: 'No response arrived. Checking whether the change was saved.',
  failed: 'The change could not be completed.',
  configure: 'Owner and mode',
  owner: 'Responsible plugin',
  none: 'No plugin',
  mode: 'Operating mode',
  save: 'Save',
  Disabled: 'Disabled',
  Copilot: 'Draft assistant',
  Shadow: 'Observation mode',
  Autopilot: 'Automatic replies',
  automation_disabled: 'AI is disabled.',
  automation_owner_missing: 'No plugin is assigned.',
  automation_owner_unavailable:
    'The plugin grant is no longer current. An administrator must reassign ownership.',
  automation_activation_required: 'Required property activation and quality approval are missing.',
  conversation_closed: 'The conversation is closed.',
  conversation_locally_resolved:
    'The conversation is manually done. A new guest message reopens it.',
  reply_not_supported: 'This channel does not support replies.',
  notReady: 'AI is not ready yet.',
  noPermission: 'Only an authorized team member can operate AI.',
};
